import React from 'react';
import useAuthGuard from '../hooks/useAuthGuard';
import Layout from '../components/Layout';

function NotificationDetail() {
    useAuthGuard();

    return (
        <Layout>

            NotificationDetail

        </Layout>
    );
}

export default NotificationDetail;
